import InputFiled from './input';
import ColorPicker from './color';
import InputNumberFiled from './input-number';
import Size from './size';
import Position from './position';
import SelectField from './select';
export const EditorPanels = {
    InputFiled,
    ColorPicker,
    InputNumberFiled,
    Size,
    Position,
    SelectField,
};
export { InputFiled, ColorPicker, InputNumberFiled, Size, Position, SelectField };
//# sourceMappingURL=index.js.map